import { ObligationRulesCategory } from '@commenda/prisma';
import { fetcher } from '@commenda/utils';
import {
  TaxAndAccountingOnboardingStatus,
  TTaxAndAccountingOnboardingAnswers,
  TTaxAndAccountingOnboardingDraft,
} from './tax-and-accounting-onboarding.types';

export type SubmitTaxAndAccountingOnboardingBody = {
  corporationId: number;
  fiscalYear: number;
  status: TaxAndAccountingOnboardingStatus;
  answers: TTaxAndAccountingOnboardingAnswers;
  /** Intake's compliance-category selection; scopes the profile-submit regeneration. */
  complianceCategories?: ObligationRulesCategory[];
  draft?: TTaxAndAccountingOnboardingDraft;
};

export type SubmitTaxAndAccountingOnboardingResponse = {
  taxAndAccountingOnboarding: { id: number };
};

export async function submitTaxAndAccountingOnboarding(
  body: SubmitTaxAndAccountingOnboardingBody
): Promise<SubmitTaxAndAccountingOnboardingResponse> {
  const response = await fetcher('tax-and-accounting-onboarding', {
    method: 'POST',
    body,
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(
      data?.message || 'Failed to submit the Tax & Accounting onboarding.'
    );
  }
  return data as SubmitTaxAndAccountingOnboardingResponse;
}
